import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

class Transition extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      mounted: false
    });
    _defineProperty(this, "timeout", null);
    _defineProperty(this, "raf", null);
  }
  static getDerivedStateFromProps(props, state) {
    if (state.mounted === false) {
      if (props.isVisible && props.isActive) {
        return {
          mounted: true,
          state: 'enter'
        };
      }
      if (props.isVisible && !props.isActive) {
        return {
          mounted: true,
          state: 'exit'
        };
      }
      if (!props.isVisible && !props.isActive) {
        return {
          mounted: true,
          state: 'exited' // Skip the exit transition all together
        };
      }

      return {
        mounted: true
      };
    } else {
      if (!props.isActive && (state.state === undefined || state.state === 'enter' || state.state === 'entering' || state.state === 'entered')) {
        return {
          state: 'exit'
        };
      }
      if (props.isActive && (state.state === undefined || state.state === 'exit' || state.state === 'exiting' || state.state === 'exited')) {
        return {
          state: 'enter'
        };
      }
    }
    return null;
  }
  notifyStateChange() {
    var {
      onChangeState
    } = this.props;
    var {
      state
    } = this.state;
    if (onChangeState) {
      onChangeState(state);
    }
  }
  enter() {
    this.notifyStateChange();
    cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => {
      var {
        timeout
      } = this.props;
      clearTimeout(this.timeout);
      this.setState({
        state: 'entering'
      }, () => {
        this.notifyStateChange();
        this.timeout = setTimeout(() => this.setState({
          state: 'entered'
        }, () => this.notifyStateChange()), timeout);
      });
    });
  }
  exit() {
    this.notifyStateChange();
    cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => {
      var {
        timeout
      } = this.props;
      clearTimeout(this.timeout);
      this.setState({
        state: 'exiting'
      }, () => {
        this.notifyStateChange();
        this.timeout = setTimeout(() => this.setState({
          state: 'exited'
        }, () => this.notifyStateChange()), timeout);
      });
    });
  }
  componentDidMount() {
    if (this.state.state === 'enter') {
      setTimeout(() => this.enter(), 0);
    }
    if (this.state.state === 'exit') {
      this.exit();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.state !== 'enter' && this.state.state === 'enter') {
      setTimeout(() => this.enter(), 0);
    }
    if (prevState.state !== 'exit' && this.state.state === 'exit') {
      this.exit();
    }
  }
  componentWillUnmount() {
    cancelAnimationFrame(this.raf);
    clearTimeout(this.timeout);
  }
  render() {
    var {
      shouldMountOnEnter,
      shouldUnmountOnExit,
      children
    } = this.props;
    var {
      state
    } = this.state;
    if (shouldMountOnEnter && state === undefined) {
      return null;
    }
    if (shouldUnmountOnExit && state === 'exited') {
      return null;
    }
    return children(state);
  }
}
var mixin = (state, options) => {
  switch (state) {
    case 'enter':
    case 'entering':
    case 'entered':
    case 'exit':
    case 'exiting':
    case 'exited':
      return options[state];
    default:
      return undefined;
  }
};
var style = (state, options) => {
  switch (state) {
    case 'enter':
    case 'entering':
    case 'entered':
    case 'exit':
    case 'exiting':
    case 'exited':
      return options[state];
    default:
      return undefined;
  }
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded = ["timeout", "children"];
var TIMEOUT = 250;
var STYLES = {
  enter: {
    opacity: '0'
  },
  entering: {
    opacity: '1'
  },
  entered: {
    opacity: '1'
  },
  exit: {
    opacity: '1'
  },
  exiting: {
    opacity: '0'
  }
};
var Fade = props => {
  var {
      timeout: customTimeout,
      children: _children
    } = props,
    transitionProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/jsx(Transition, _objectSpread2(_objectSpread2({
    timeout: customTimeout !== null && customTimeout !== void 0 ? customTimeout : TIMEOUT
  }, transitionProps), {}, {
    children: state => /*#__PURE__*/jsx("div", {
      style: _objectSpread2({
        opacity: 0,
        transition: "opacity ".concat(TIMEOUT / 1000, "s")
      }, style(state, STYLES)),
      children: _children
    })
  }));
};

export { Fade, Transition as default, mixin };
